var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaypromptLogoSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_462)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#120A8F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 16,
    width: 36,
    height: 56,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 16C62.4183 16 66 19.5817 66 24V64H55V72H42C39.7909 72 38 73.7909 38 76C38 78.2091 39.7909 80 42 80H38C33.5817 80 30 76.4183 30 72V24C30 19.5817 33.5817 16 38 16H58Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 44,
    r: 14,
    fill: "#38C63A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5858 38.5859C53.3668 37.8049 54.6329 37.8049 55.4139 38.5859C56.195 39.367 56.195 40.633 55.4139 41.4141L47.4139 49.4141C46.6329 50.1951 45.3668 50.1951 44.5858 49.4141L40.5858 45.4141C39.8047 44.633 39.8047 43.367 40.5858 42.5859C41.3668 41.8049 42.6329 41.8049 43.4139 42.5859L45.9998 45.1719L52.5858 38.5859Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_462"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypromptLogoSmall);
export default __webpack_public_path__ + "static/media/paypromptLogoSmall.65a1be8b5356555d9dc4fdec4197745b.svg";
export { ForwardRef as ReactComponent };